import React, { useState, useEffect } from 'react'
import { Modal, Form, InputNumber, App } from 'antd'
import { useKaipiaodanCWCHMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
import dayjs from 'dayjs'
function InvoiceFinanceAmount(props) {  
  const { message } = App.useApp()
  const [open, setOpen] = useState(false)
  const [info, setInfo] = useState({
    kpsq_id:props.kpsq_id,
    kpsq_state: props.kpsq_state,
    kpsq_cw_content:'',
    kpsq_amount:props.kpsq_amount,
  })
  const [form] = Form.useForm()
  const [updateSave] = useKaipiaodanCWCHMutation()
  useEffect(() => {
    form.setFieldsValue({
        kpsq_id:props.kpsq_id,
        kpsq_state: props.kpsq_state,
        kpsq_cw_content:'',
        kpsq_amount:props.kpsq_amount,
    })
  }, [props.kpsq_id, props.kpsq_state, props.kpsq_amount, form])
  return (
    <>
        <Icon type='financeAmount' onClick={() => setOpen(true)} />
        <Modal
            title='开票申请改金额'
            open={open}
            onCancel={() => setOpen(false)}
            onOk={() => {
                updateSave({
                    kpsq_id:props.kpsq_id,
                    kpsq_state: props.kpsq_state,
                    kpsq_cw_content:props.kpsq_cw_content+`！${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：开票申请改金额，原始价格为${props.kpsq_amount}`,
                    kpsq_amount:info.kpsq_amount,
                }).then((res) => {
                    if(res.data.Status === 'success') {
                        message.success('开票申请改金额成功！')
                        setOpen(false)
                    } else {
                        message.error('开票申请改金额失败！'+res.data.Message)
                    }
                }).catch((err) => {
                        message.error('开票申请改金额失败！'+err.message)
                })
            }}
        >
            <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                <Form.Item label='金额' name='kpsq_amount' rules={[{ required: true, message: '请输入金额' }]}>
                    <InputNumber 
                        min={0.01} 
                        max={99999999.99} 
                        step={0.01} 
                        onChange={(value) => {
                            setInfo(prev => ({ ...prev, kpsq_amount: value }))
                        }}
                        style={{ width: '100%' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    </>
  )
}


    export default InvoiceFinanceAmount